import { render, staticRenderFns } from "./MySubscriptions.vue?vue&type=template&id=60818d1a&scoped=true&"
import script from "./MySubscriptions.vue?vue&type=script&lang=ts&"
export * from "./MySubscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./MySubscriptions.vue?vue&type=style&index=0&id=60818d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60818d1a",
  null
  
)

export default component.exports